import { Component, inject, input, output } from '@angular/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';

import { BaseComponent } from '../../base/base.component';
import { ModalService } from '../../../services';
import { GridComponent } from '../../grids/grid/grid.component';

@Component({
  selector: 'app-import-preview-modal',
  templateUrl: './import-preview-modal.component.html',
  styleUrl: './import-preview-modal.component.scss',
  imports: [GridComponent],
})
export class ImportPreviewModalComponent extends BaseComponent {
  protected readonly modalService = inject(ModalService);

  public readonly title = input('');
  public readonly columnDefs = input<ColDef[]>([]);
  public readonly rowData = input<any[]>([]);

  public readonly newCount = input(0);
  public readonly updateCount = input(0);
  public readonly invalidCount = input(0);
  public readonly warningCount = input(0);
  public readonly validCount = input(0);

  public readonly hasErrors = input(false);
  public readonly hasValidRows = input(false);

  public readonly confirm = output<void>();

  confirmImport() {
    this.confirm.emit();
  }
}
